<template>
  <div class="filter">
    <div id="rdco_placeholder">
      <div class="one-third column">
        <label for="f1">Primary Noise, Freq. (Hz)</label>
        <number-input
          :min="1500"
          :max="12000"
          :class="{'has-error': errors.f1}"
          size="small"
          inline
          v-model="form.f1"
          :attrs="{id: 'f1'}"
        />
        <label for="t1">Primary Noise, Pad Temp. (°C)</label>
        <number-input
          :min="-30"
          :max="150"
          :class="{'has-error': errors.T1}"
          size="small"
          inline
          v-model="form.T1"
          :attrs="{id: 't1'}"
        />
      </div>
      <div class="one-third column">
        <label for="f2">Secondary Noise, Freq. (Hz)</label>
        <number-input
          :min="1500"
          :max="12000"
          :class="{'has-error': errors.f2}"
          size="small"
          inline
          v-model="form.f2"
          :attrs="{id: 'f2'}"
        />
        <label for="t2">Secondary Noise, Pad Temp. (°C)</label>
        <number-input
          :min="-30"
          :max="150"
          :class="{'has-error': errors.T2}"
          size="small"
          inline
          v-model="form.T2"
          :attrs="{id: 't2'}"
        />
      </div>
      <div class="one-third column">
        <label for="f3">Tertiary Noise, Freq. (Hz)</label>
        <number-input
          :min="1500"
          :max="12000"
          :class="{'has-error': errors.f3}"
          size="small"
          inline
          v-model="form.f3"
          :attrs="{id: 'f3'}"
        />
        <label for="t3">Tertiary Noise, Pad Temp. (°C)</label>
        <number-input
          :min="-30"
          :max="150"
          :class="{'has-error': errors.T3}"
          size="small"
          inline
          :attrs="{id: 't3'}"
          v-model="form.T3"
        />
      </div>
      <div class="one-third column last">
        <label for="t">Max. Nominal Thickness (mm)</label>
        <number-input
          size="small"
          inline
          v-model="form.t"
          :attrs="{id: 't'}"
          :min="0.65"
          :step="0.01"
        />
        <label for="EPB">Approved for EPB</label>
        <input type="checkbox" :value="true" id="EPB" name="EPB" v-model="form.EPB" />
        <template v-if="showSearchAll">
          <label for="searchAll">Search All Materials</label>
          <input type="checkbox" value="1" id="searchAll" v-model="form.searchAll" />
        </template>
      </div>
      <br />
      <br class="clear" />
      <button name="search" class="sky-blue medium" @click="submit" :disabled="loading">Search</button>
      <p class="error" v-text="error"></p>
    </div>
  </div>
</template>

<script>
import NumberInput from "./number-input.vue";
import Validate from "validate.js";

export default {
  props: {
    config: {
      type: Object,
      defualt() {
        return {};
      }
    },
    queryData: {
      type: Object,
      default() {
        return {};
      }
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: "" }
  },
  data() {
    return {
      errors: {},
      form: {
        T1: NaN,
        f1: NaN,
        T2: NaN,
        f2: NaN,
        T3: NaN,
        f3: NaN,
        t: NaN,
        EPB: false,
        searchAll: false
      }
    };
  },
  mounted() {
    this.form = Object.assign({}, this.form, this.queryData);
  },
  methods: {
    submit() {
      if (this.validData) {
        this.errors = {};
        this.$emit("submit", this.submitData);
      } else {
        this.errors = Object.assign({}, this.validateInput);
      }
    }
  },
  computed: {
    validData() {
      return Object.entries(this.submitData).length > 0 &&
        Object.entries(this.validateInput) <= 0
        ? true
        : false;
    },
    validateInput() {
      let validation = Validate(this.form, {
        T1: {
          numericality: true
        },
        f1: {
          numericality: true
        },
        T2: {
          numericality: this.form.f2 > 0
        },
        f2: {
          numericality: this.form.T2 > 0
        },
        T3: {
          numericality: this.form.f3 > 0
        },
        f3: {
          numericality: this.form.T3 > 0
        }
      });

      return validation ? validation : {};
    },
    showSearchAll() {
      return this.config.show_search_all === "1" ? true : false;
    },
    submitData() {
      let data = {};
      for (let i in this.form) {
        if (this.form[i] === true) {
          data[i] = true;
        } else if (!isNaN(this.form[i]) && typeof this.form[i] === "number") {
          data[i] = this.form[i];
        }
      }

      return data;
    }
  },
  components: {
    NumberInput
  }
};
</script>